import { render, staticRenderFns } from "./ViewAdjustment.vue?vue&type=template&id=87904a24&scoped=true"
import script from "./ViewAdjustment.vue?vue&type=script&lang=js"
export * from "./ViewAdjustment.vue?vue&type=script&lang=js"
import style0 from "./ViewAdjustment.vue?vue&type=style&index=0&id=87904a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87904a24",
  null
  
)

export default component.exports